<script>

/* stato di una notizia */

export default {
  props: {
    enabled: {
      required: true
    }
  },
  computed: {
    userStatus () {
      return this.enabled ? this.$t('utenti.status.abilitato') : this.$t('utenti.status.non_abilitato')
    },
    userColor () {
      return this.enabled ? 'success' : 'error'
    }
  }
}
</script>

<template>
  <span>
    <v-chip
      text-color="white"
      small
      :color="this.userColor">
      {{ userStatus }}
    </v-chip>
  </span>
</template>
